import { render, staticRenderFns } from "./ConceptView.vue?vue&type=template&id=42790e6f&"
import script from "./ConceptView.vue?vue&type=script&lang=ts&"
export * from "./ConceptView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports